export enum OrderDir {
  ASC = 'asc',
  DESC = 'desc',
}

export const MIN_SEARCH_LENGTH = 3
